import DisconnectedModal from './DisconnectedModal';

export default DisconnectedModal;